import { Children, cloneElement } from 'react';
import { DropdownMenu } from 'client/components/DropdownMenu';
import { useDevelopBlocker } from './useDevelopBlocker';

interface DevelopButtonBlockerProps {
  target: string;
  startingWarning: string;
  stoppedWarning: string;
  children: JSX.Element;
}

export const DevelopButtonBlocker = ({ target, startingWarning, stoppedWarning, children }: DevelopButtonBlockerProps) => {
  const { menuItems, isWarningDisplayed, isErrorDisplayed, handleInactiveLog } = useDevelopBlocker({
    target,
    startingWarning,
    stoppedWarning,
  });

  const child = Children.only(children);

  const button = cloneElement(child, {
    ...child.props,
    onClick: !isWarningDisplayed && !isErrorDisplayed ? children.props.onClick : handleInactiveLog,
  });

  if (isWarningDisplayed || isErrorDisplayed) {
    return <DropdownMenu items={menuItems}>{button}</DropdownMenu>;
  }

  return button;
};
